package com.macrofocus.eflux.animation

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.common.selection.MutableSelection
import com.macrofocus.eflux.network.EFluxNode
import com.macrofocus.eflux.network.logical.LogicalBranchId
import com.macrofocus.eflux.network.logical.LogicalBusId
import svgpanzoom.SvgPanZoomContext

abstract class CompositeAnimation : Animation {
    abstract fun addAnimation(animation: Animation)

    fun property(property : MutableProperty<Double>, endValue: Double, duration: Long, easing: Easing = Easing.LINEAR, init: PropertyAnimation.() -> Unit = {}) : PropertyAnimation {
        val animation = PropertyAnimation(property, endValue, duration, easing)
        animation.init()
        addAnimation(animation)
        return animation
    }

    fun zoom(svgPanZoomContext: SvgPanZoomContext, endZoom: Double, duration: Long, easing: Easing = Easing.LINEAR, init: ZoomAnimation.() -> Unit = {}) : ZoomAnimation {
        val animation = ZoomAnimation(svgPanZoomContext, endZoom, duration, easing)
        animation.init()
        addAnimation(animation)
        return animation
    }

    fun zoomAtPoint(to: EFluxNode?, svgPanZoomContext: SvgPanZoomContext, endZoom: Double, duration: Long, easing: Easing = Easing.LINEAR, init: ZoomAtPointAnimation.() -> Unit = {}) : ZoomAtPointAnimation {
        val animation = ZoomAtPointAnimation(to, svgPanZoomContext, endZoom, duration, easing)
        animation.init()
        addAnimation(animation)
        return animation
    }

    fun pan(from: EFluxNode, to: EFluxNode, svgPanZoomContext: SvgPanZoomContext, duration: Long, easing: Easing = Easing.LINEAR, init: PanAnimation.() -> Unit = {}) : PanAnimation {
        val animation = PanAnimation(from, to, svgPanZoomContext, duration, easing)
        animation.init()
        addAnimation(animation)
        return animation
    }

    fun panTo(to: EFluxNode?, svgPanZoomContext: SvgPanZoomContext, duration: Long, easing: Easing = Easing.LINEAR, init: PanToAnimation.() -> Unit = {}) : PanToAnimation {
        val animation = PanToAnimation(to, svgPanZoomContext, duration, easing)
        animation.init()
        addAnimation(animation)
        return animation
    }

    fun onZoom(svgPanZoomContext: SvgPanZoomContext, property : MutableProperty<Boolean>, zoomThreshold: Double, duration: Long, init: OnZoomAnimation.() -> Unit = {}) : OnZoomAnimation {
        val animation = OnZoomAnimation(svgPanZoomContext, property, zoomThreshold, duration)
        animation.init()
        addAnimation(animation)
        return animation
    }

    fun select(node: LogicalBusId?, selection: MutableSelection<LogicalBusId>, duration: Long, init: SelectNodeAnimation.() -> Unit = {}) : SelectNodeAnimation {
        val animation = SelectNodeAnimation(node, selection, duration)
        animation.init()
        addAnimation(animation)
        return animation
    }

    fun select(link: LogicalBranchId?, selection: MutableSelection<LogicalBranchId>, duration: Long, init: SelectLinkAnimation.() -> Unit = {}) : SelectLinkAnimation {
        val animation = SelectLinkAnimation(link, selection, duration)
        animation.init()
        addAnimation(animation)
        return animation
    }
}